export default class EstersektService {
  constructor() {
    this.entersektUrl = JSON.parse(process.env.REACT_APP_ENTERSEKT_URL);
    this.channelId = JSON.parse(process.env.REACT_APP_ENTERSEKT_CHANNEL_ID);
    this.customerAuthnSDK = null;
  }

  async init(Session) {
    try {

      if (!window.CustomerAuthn || !window.CustomerAuthn.configBuilder) {
          return;
      }

      const index = this.entersektUrl.indexOf(window.location.origin);
      if (index === -1) {
          return;
      }
      
      const config = window.CustomerAuthn.configBuilder
          .setTokenEndpointURL("https://endpoint-auth.ue1.ehs.entersekt.com/token")
          .setChannelShortName(this.channelId[index])
          .setSignalCollectorURL("https://signal-collector.ue1.ehs.entersekt.com")
          .setSessionID(Session)
          .setFingerprintConfig({
              agentDownloadPath: "https://signal-collector.ue1.ehs.entersekt.com/7kd5Yzbew3/V2AKPO82Vn?apiKey=tAzOxn2Z7bGCVpXQvYaT",
              getResultPath: "https://signal-collector.ue1.ehs.entersekt.com/7kd5Yzbew3/O3zzXvbNmF?region=us",
            })
          .build();

      this.customerAuthnSDK = await window.CustomerAuthn.init(config);
      const sdkInfo = await this.customerAuthnSDK.getSDKInfo();

      if (sdkInfo && sdkInfo.endpointID) {
          sessionStorage.setItem("endpointIdEntersekt", sdkInfo.endpointID);
      }

      await this.customerAuthnSDK.riskSignals.startCollecting({ uiPageID: "CFC-submit-application" });

    } catch (error) {
        console.error("[Entersekt] Initialization error:", error);
    }
  }


  async submit() {
    if(!!this.customerAuthnSDK)
      await this.customerAuthnSDK.riskSignals.submitCollected({  interactionType: "OPEN_BANK_ACCOUNT", });      
  }
}